import React, { useEffect, useState } from "react";
import Footer from "../components/Shared/Footer";
import { useNavigate } from "react-router-dom";
import { fetchProducts, addToCart, updateCart, fetchCart } from "../api/ShopHelper";
import { isLoggedIn } from "../api/auth";
import { getUserId, getAccesstoken } from "../utils/auth";
import Modal from "../components/Shared/Modal";
import axios from "axios";

const Shop = () => {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [quantityByProduct, setQuantityByProduct] = useState({}); // Quantity per product
  const [cart, setCart] = useState([]);
  const [cartCount, setCartCount] = useState(0);
  const [addToCartSuccess, setaddToCartSuccess] = useState("");
  const navigate = useNavigate();
  const access_token = getAccesstoken();
  const user_id = getUserId();
  const isUserloggedIn = isLoggedIn();

  useEffect(() => {
    const loadProducts = async () => {
      try {
        const sortedProducts = await fetchProducts(access_token);
        setProducts(sortedProducts);

        const initialQuantities = {};
        sortedProducts.forEach((product) => {
          initialQuantities[product.id] = 1;
        });
        setQuantityByProduct(initialQuantities);

        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    loadProducts();
  }, [access_token]);

  const handleQuantityChange = (productId, action) => {
    setQuantityByProduct((prevQuantities) => ({
      ...prevQuantities,
      [productId]: Math.max(1, prevQuantities[productId] + (action === "increase" ? 1 : -1)),
    }));
  };

  const handleAddToCart = async (productId) => {
    if (!access_token) {
      navigate("/login?path=shop");
    } else {
      try {
        const product = products.find((p) => p.id === productId);
        if (!product) {
          alert("Product data is missing.");
          return;
        }

        // Reset the success state before starting new operation
        setaddToCartSuccess(false);

        // Get cart_id first
        const cart_id = await fetchCart(user_id, access_token);
        
        let existingCartItem = null;
        
        try {
          // Check if product already exists in cart
          const cartItemsResponse = await axios.get(
            `${baseUrl}/cart_items/filter_by_user_id_cart_id`,
            {
              params: { user_id, cart_id },
              headers: { Authorization: `Bearer ${access_token}` },
            }
          );

          if (cartItemsResponse.data) {
            existingCartItem = cartItemsResponse.data.find(
              item => item.product_id === productId
            );
          }
        } catch (error) {
          console.log(error);
        }

        const quantity = quantityByProduct[productId];
        const discountPercentage = product.discount || 0;
        const discountedPrice = discountPercentage > 0 
          ? product.price * (1 - discountPercentage / 100) 
          : product.price;

        if (existingCartItem) {
          const updatedCartData = {
            user_id: user_id,
            product_id: productId,
            cart_id: cart_id,
            quantity: existingCartItem.quantity + quantity,
            unit_price: discountedPrice,
            updated_at: new Date().toISOString(),
          };

          const response = await updateCart(existingCartItem.id, updatedCartData, access_token);
          // localStorage.setItem()
          // console.log(response.data.quantity)
          if (response) {
            setaddToCartSuccess(true);
            // Clear modal and backdrop after delay
            setTimeout(() => {
              setaddToCartSuccess(false);
              // Remove any lingering backdrop
              const backdrop = document.querySelector('.modal-backdrop');
              if (backdrop) {
                backdrop.remove();
              }
              // Remove modal-open class from body
              document.body.classList.remove('modal-open');
              // Reset any inline styles added to body
              document.body.style.overflow = '';
              document.body.style.paddingRight = '';
            }, 2000);
            setCartCount(cartCount + quantity);
          }
        } else {
          const cartData = {
            user_id,
            product_id: productId,
            cart_id,
            quantity,
            unit_price: discountedPrice,
            created_at: new Date().toISOString(),
          };

          const response = await addToCart(cartData, access_token);
          if (response) {
            setaddToCartSuccess(true);
            // Clear modal and backdrop after delay
            setTimeout(() => {
              setaddToCartSuccess(false);
              // Remove any lingering backdrop
              const backdrop = document.querySelector('.modal-backdrop');
              if (backdrop) {
                backdrop.remove();
              }
              // Remove modal-open class from body
              document.body.classList.remove('modal-open');
              // Reset any inline styles added to body
              document.body.style.overflow = '';
              document.body.style.paddingRight = '';
            }, 2000);
            setCartCount(cartCount + quantity);
          }
        }
      } catch (error) {
        console.error("Error handling cart operation:", error);
        alert("An error occurred while updating the cart.");
      }
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Shop</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">Shop</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="container-fluid-lg" style={{ paddingBottom: "100px" }}>
        <div className="product-list-section list-style">
          {products.map((product) => {
            const discountPercentage = product.discount || 0;  // Assuming you have a discount field in the product object
            const discountedPrice = discountPercentage > 0 ? product.price * (1 - discountPercentage / 100) : product.price;
            return (

              <div key={product.id} className="col-md-6">
                <div
                  className="row product-box-3 h-100 wow fadeInUp"
                  style={{
                    visibility: "visible",
                    animationName: "fadeInUp",
                    marginTop: "50px",
                  }}
                >
                  <div className="col-md-4">
                    <div className="product-image">
                      <a href={`/product/${product.id}`}>
                        <div className="custom-image-container fresh-image-2">
                          <img
                            src={`../assets/images/products/${product.product_image}`}
                            alt=""
                            className="custom-image blur-up-img lazyloaded-img rounded-corners"
                          />
                        </div>
                      </a>
                    </div>
                  </div>
                  <div className="col-md-8">
                    <div className="product-detail">
                      <span className="span-name">{product.category}</span>
                      <a href={`/product/${product.id}`}>
                        <h2 className="name">{product.name}</h2>
                      </a>
                      <p className="text-content mt-3 mb-2 product-content">
                        {product.description}
                      </p>
                      <h6 className="unit">{product.unit}</h6>
                      <div className="price-rating" style={{ display: 'flex', alignItems: 'center' }}>
                        <h3 className="theme-color price" style={{ marginRight: '10px' }}>₹{discountedPrice.toFixed(2)}</h3>
                        {discountPercentage > 0 && (
                          <h3 className="price" style={{ color: '#6c757d', textDecoration: 'line-through', marginRight: '10px' }}>
                            ₹{product.price}
                          </h3>
                        )}
                        {discountPercentage > 0 && (
                          <h3 className="discount" style={{ marginLeft: '10px', color: 'red', fontWeight: 'bold' }}>
                            {discountPercentage}% Off
                          </h3>
                        )}
                      </div>
                      <div className="note-box product-package">
                        <div className="cart_qty qty-box product-qty">
                          <div className="input-group">
                            <button
                              type="button"
                              className="qty-left-minus"
                              onClick={() =>
                                handleQuantityChange(product.id, "decrease")
                              }
                            >
                              <i className="fa fa-minus"></i>
                            </button>
                            <input
                              className="form-control input-number qty-input"
                              type="text"
                              value={quantityByProduct[product.id] || 1}
                              readOnly
                            />
                            <button
                              type="button"
                              className="qty-right-plus"
                              onClick={() =>
                                handleQuantityChange(product.id, "increase")
                              }
                            >
                              <i className="fa fa-plus"></i>
                            </button>
                          </div>
                        </div>

                        {/* <button
                          onClick={() => handleAddToCart(product.id)}
                          className="btn btn-md cart-button text-white text-start"
                          style={{
                            backgroundColor: "#3150A3",
                            fontWeight: "bold",
                            width: '20%'
                          }}
                        >
                          ADD TO CART
                        </button> */}
                        <div className="w-100">
  <button
    onClick={() => handleAddToCart(product.id)}
    className="btn btn-md cart-button text-white add-to-cart-btn"
  >
    ADD TO CART
  </button>
</div>


                      </div>
                      {product.additional_details &&
                        product.additional_details.offerings &&
                        product.additional_details.offerings.length > 0 && (
                          <div className="add-on-services mt-3">
                            <h5>Offerings:</h5>
                            <ul>
                              {product.additional_details.offerings.slice(0, 4).map((offering, index) => (
                                <li key={index}>
                                  <div
                                    className="font-sm fas fa-check"
                                    style={{ color: "#75C043" }}
                                  ></div>{" "}
                                  {offering.name}
                                </li>
                              ))}
                              {product.additional_details.offerings.length > 4 && (
                                <li>
                                  <a href={`/product/${product.id}`} className="view-more">
                                    View more...
                                  </a>
                                </li>
                              )}
                            </ul>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            )
          })}
          
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '20px' }}>
  <button
    className="btn btn-md cart-button text-white add-to-cart-btn text-center"
    onClick={() => navigate("/cart")}
  >
    Proceed To Payment
  </button>
</div>


        </div>
      </div>

      {addToCartSuccess && (
        <Modal
          title="Product Added!"
          modalType="success"
          bodyText="Product added to cart successfully.."
          modalId="loginModal"
          onClose={() => {
            setaddToCartSuccess(false);
            // Remove any lingering backdrop
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
              backdrop.remove();
            }
            // Remove modal-open class from body
            document.body.classList.remove('modal-open');
            // Reset any inline styles added to body
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
          }}
        />
      )}

      <Footer />
    </div>
  );
};

export default Shop;
